<template>
  <header class="py-3">
      <div class="container-md">
          <h2 class="text-white">Ghibli Studio DB</h2>
      </div>
  </header>
</template>

<script>
export default {

}
</script>

<style>

</style>